import React from "react";

const Users = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2565_1884)">
      <path
        d="M10.0005 12.9998C10.0005 13.5302 10.2112 14.0389 10.5862 14.414C10.9613 14.789 11.47 14.9998 12.0005 14.9998C12.5309 14.9998 13.0396 14.789 13.4147 14.414C13.7897 14.0389 14.0005 13.5302 14.0005 12.9998C14.0005 12.4693 13.7897 11.9606 13.4147 11.5855C13.0396 11.2105 12.5309 10.9998 12.0005 10.9998C11.47 10.9998 10.9613 11.2105 10.5862 11.5855C10.2112 11.9606 10.0005 12.4693 10.0005 12.9998Z"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00052 20.9998V19.9998C8.00052 19.4693 8.21123 18.9606 8.58631 18.5855C8.96138 18.2105 9.47009 17.9998 10.0005 17.9998H14.0005C14.531 17.9998 15.0397 18.2105 15.4147 18.5855C15.7898 18.9606 16.0005 19.4693 16.0005 19.9998V20.9998"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0005 4.99976C15.0005 5.53019 15.2113 6.0389 15.5863 6.41397C15.9614 6.78904 16.4701 6.99976 17.0005 6.99976C17.531 6.99976 18.0397 6.78904 18.4148 6.41397C18.7898 6.0389 19.0005 5.53019 19.0005 4.99976C19.0005 4.46932 18.7898 3.96061 18.4148 3.58554C18.0397 3.21047 17.531 2.99976 17.0005 2.99976C16.4701 2.99976 15.9614 3.21047 15.5863 3.58554C15.2113 3.96061 15.0005 4.46932 15.0005 4.99976Z"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0005 9.99951H19.0005C19.531 9.99951 20.0397 10.2102 20.4147 10.5853C20.7898 10.9604 21.0005 11.4691 21.0005 11.9995V12.9995"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00058 4.99976C5.00058 5.53019 5.21129 6.0389 5.58637 6.41397C5.96144 6.78904 6.47015 6.99976 7.00058 6.99976C7.53101 6.99976 8.03972 6.78904 8.41479 6.41397C8.78987 6.0389 9.00058 5.53019 9.00058 4.99976C9.00058 4.46932 8.78987 3.96061 8.41479 3.58554C8.03972 3.21047 7.53101 2.99976 7.00058 2.99976C6.47015 2.99976 5.96144 3.21047 5.58637 3.58554C5.21129 3.96061 5.00058 4.46932 5.00058 4.99976Z"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.00085 12.9995V11.9995C3.00085 11.4691 3.21157 10.9604 3.58664 10.5853C3.96171 10.2102 4.47042 9.99951 5.00085 9.99951H7.00085"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2565_1884">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Users;
